import { render } from "./NotificationComponent.vue?vue&type=template&id=47015e22&scoped=true&ts=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=ts"
export * from "./NotificationComponent.vue?vue&type=script&lang=ts"

import "./NotificationComponent.vue?vue&type=style&index=0&id=47015e22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47015e22"]])

export default __exports__